type BaseItem = {
  id?: string | number;
  label?: string;
  name?: string;
  courier_id?: string | number;
  courier_name?: string;
};

interface ApplyConfig<T extends BaseItem> {
  key: string;
  label: string;
  list: T[];
  getId: (x: T) => string | number;
  stateKey: string;
  applyCourierId: boolean;
}

import theme from '@/assets/theme';
import { NotificationFilterApplyEnum } from '../../../common/enum';
import { themeT } from '@/utils/themeText';

export const getApplyConfig = ({
  teamsList,
  origins,
  products,
  couriers,
  destinations,
}: {
  teamsList: BaseItem[];
  origins: BaseItem[];
  products: BaseItem[];
  couriers: BaseItem[];
  destinations: BaseItem[];
}): Record<NotificationFilterApplyEnum, ApplyConfig<BaseItem>> => {
  return {
    [NotificationFilterApplyEnum.Teams]: {
      key: 'filter_teams',
      label: `${themeT('team', theme.themeType)}s`,
      list: teamsList,
      getId: (x) => x.id,
      stateKey: 'select_all_teams',
      applyCourierId: false,
    },
    [NotificationFilterApplyEnum.Origin]: {
      key: 'filter_origins',
      label: 'Origin',
      list: origins,
      getId: (x) => x.id,
      stateKey: 'select_all_origins',
      applyCourierId: false,
    },
    [NotificationFilterApplyEnum.Product]: {
      key: 'products',
      label: 'Product',
      list: products,
      getId: (x) => x.id,
      stateKey: 'select_all_products',
      applyCourierId: false,
    },
    [NotificationFilterApplyEnum.Couriers]: {
      key: 'filter_transport_providers',
      label: `${themeT('transportProvider', theme.themeType)}`,
      list: couriers,
      getId: (x) => x.courier_id ?? '',
      stateKey: 'select_all_transport_providers',
      applyCourierId: true,
    },
    [NotificationFilterApplyEnum.Destination]: {
      key: 'filter_destinations',
      label: 'Destination',
      list: destinations,
      getId: (x) => x.id,
      stateKey: 'select_all_destinations',
      applyCourierId: false,
    },
  };
};
